import { BASE_URL } from "../envVariables";

export const baseURL = BASE_URL;

console.info("Base URL", baseURL);
